<template>
	<Scroller id="global" ref="mainScroller" :main="true">
		<NuxtPage />
	</Scroller>

	<PreLoader :title="`${SITE_NAME} — ${SITE_DESCRIPTION}`" />

	<Grid />
</template>

<script setup>
import { SITE_NAME, SITE_DESCRIPTION } from './config/site'

import { Grid, Scroller, PreLoader } from '@/components/core'
const mainScroller = ref(null)

onMounted(() => {})

provide('$scroller', mainScroller)
</script>

<style lang="scss" scoped>
[data-component='pre-loader'] {
	--preload-color: var(--color-geral-brown);
}
</style>
